export const accept_message = `mutation accept_message($input: Int!){
    accept_message(input: $input)
}`;
